export default __webpack_public_path__ + "static/media/recipes_icon_black.be5dc8f8.svg";